import { VerificationType, VerificationContext } from '../../lib/types';
import { WellKnownEnum, WellKnownAttribute } from './types';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateWellKnownDid = /* @__PURE__ */ __name(({ wellKnown, newKeyPair }) => {
  if (!newKeyPair) {
    return;
  }
  if (wellKnown?.verificationMethod?.find((s) => {
    return newKeyPair.type === VerificationType.Bls12381G2Key2020 && s?.publicKeyBase58 && s?.publicKeyBase58 === newKeyPair?.publicKeyBase58 || newKeyPair.type === VerificationType.EcdsaSecp256k1RecoveryMethod2020 && s?.blockchainAccountId && s?.blockchainAccountId === newKeyPair?.blockchainAccountId || newKeyPair.type === VerificationType.Multikey && s?.publicKeyMultibase && s?.publicKeyMultibase === newKeyPair?.publicKeyMultibase;
  })) {
    throw new Error("KeyPair already exists");
  }
  if (!wellKnown) {
    wellKnown = {
      id: newKeyPair?.controller,
      [WellKnownEnum.VERIFICATION_METHOD]: [],
      "@context": [
        "https://www.w3.org/ns/did/v1"
      ]
    };
  }
  if (!wellKnown.id) {
    wellKnown.id = newKeyPair.controller;
  }
  const context = [
    "https://www.w3.org/ns/did/v1",
    VerificationContext[newKeyPair.type]
  ];
  if (!wellKnown["@context"]) {
    wellKnown["@context"] = context;
  } else {
    if (typeof wellKnown["@context"] === "string") {
      wellKnown["@context"] = [
        wellKnown["@context"]
      ];
    }
    for (const c of context) {
      if (!wellKnown["@context"].includes(c)) {
        wellKnown["@context"].push(c);
      }
    }
  }
  const newVerificationMethod = {
    type: newKeyPair.type,
    id: newKeyPair.id,
    controller: newKeyPair.controller
  };
  if (newKeyPair.type === VerificationType.Bls12381G2Key2020 && newKeyPair.publicKeyBase58) {
    newVerificationMethod.publicKeyBase58 = newKeyPair.publicKeyBase58;
  } else if (newKeyPair.type === VerificationType.EcdsaSecp256k1RecoveryMethod2020 && newKeyPair.blockchainAccountId) {
    newVerificationMethod.blockchainAccountId = newKeyPair.blockchainAccountId;
  } else if (newKeyPair.type === VerificationType.Multikey && newKeyPair.publicKeyMultibase) {
    newVerificationMethod.publicKeyMultibase = newKeyPair.publicKeyMultibase;
  }
  if (!wellKnown[WellKnownEnum.VERIFICATION_METHOD]) {
    wellKnown[WellKnownEnum.VERIFICATION_METHOD] = [
      newVerificationMethod
    ];
  } else if (!wellKnown[WellKnownEnum.VERIFICATION_METHOD]?.find((s) => s?.id === newVerificationMethod?.id)) {
    wellKnown[WellKnownEnum.VERIFICATION_METHOD].push(newVerificationMethod);
  } else {
    throw new Error("Key already exists");
  }
  for (const type of WellKnownAttribute) {
    if (!wellKnown[type]) {
      wellKnown[type] = [
        newVerificationMethod?.id
      ];
    } else {
      if (!wellKnown[type]?.includes(newVerificationMethod?.id)) wellKnown[type].push(newVerificationMethod?.id);
    }
  }
  return wellKnown;
}, "generateWellKnownDid");
const nextKeyId = /* @__PURE__ */ __name((wellKnown) => {
  const keyIds = wellKnown?.verificationMethod?.map((s) => s?.id) ?? [];
  const keyIdNumbers = keyIds.map((s) => {
    const parts = s?.split("#");
    if (!parts || parts.length < 2) return null;
    const fragment = parts[parts.length - 1];
    if (!fragment?.includes("keys-")) return null;
    return fragment.split("keys-")[1];
  }).filter((s) => s !== null && s !== void 0);
  const keyIdNumbersFiltered = keyIdNumbers.filter((s) => !isNaN(Number(s))).map((s) => Number(s));
  if (keyIdNumbersFiltered.length === 0) return 1;
  const maxKeyId = Math.max(...keyIdNumbersFiltered);
  return maxKeyId + 1;
}, "nextKeyId");

export { generateWellKnownDid, nextKeyId };
